var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "card m-2" }, [
    _c("div", { staticClass: "card-header" }, [
      _c("div", { staticClass: "d-flex flex-row align-items-center" }, [
        _c("b", { staticClass: "mr-auto" }, [_vm._v(_vm._s(_vm.flow))]),
        _vm._v(" "),
        _vm.edit
          ? _c("div", [
              _c(
                "button",
                {
                  staticClass: "float-right btn btn-secondary",
                  attrs: { disabled: !_vm.edit },
                  on: { click: _vm.clearSelection }
                },
                [_vm._v(_vm._s(_vm.$t("btnCancel")))]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "float-right btn btn-primary",
                  attrs: { disabled: !_vm.edit },
                  on: { click: _vm.saveInformation }
                },
                [_vm._v(_vm._s(_vm.$t("btnSave")))]
              )
            ])
          : _c("div", [
              _c(
                "button",
                {
                  staticClass: "float-right btn btn-success",
                  attrs: { hidden: "" },
                  on: { click: _vm.printInformation }
                },
                [_vm._v(_vm._s(_vm.$t("btnPrint")))]
              )
            ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "card-body" }, [
      _c("div", { staticClass: "row mb-1" }, [
        _c("div", { staticClass: "col-sm-4" }, [
          _vm._v(" " + _vm._s(_vm.$t("txtName")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-8" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.selectedPoi.name,
                expression: "selectedPoi.name"
              }
            ],
            staticClass: "form-control",
            attrs: { disabled: !_vm.edit, type: "text" },
            domProps: { value: _vm.selectedPoi.name },
            on: {
              input: function($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.selectedPoi, "name", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mb-1" }, [
        _c("div", { staticClass: "col-sm-4" }, [
          _vm._v(" " + _vm._s(_vm.$t("txtType")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-8" }, [
          _c(
            "select",
            {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.selectedPoi.type,
                  expression: "selectedPoi.type"
                }
              ],
              staticClass: "form-control",
              attrs: { disabled: !_vm.edit },
              on: {
                change: [
                  function($event) {
                    var $$selectedVal = Array.prototype.filter
                      .call($event.target.options, function(o) {
                        return o.selected
                      })
                      .map(function(o) {
                        var val = "_value" in o ? o._value : o.value
                        return val
                      })
                    _vm.$set(
                      _vm.selectedPoi,
                      "type",
                      $event.target.multiple ? $$selectedVal : $$selectedVal[0]
                    )
                  },
                  function($event) {
                    return _vm.changeTypeOfPoI()
                  }
                ]
              }
            },
            [
              _c("option", { domProps: { value: 0 } }, [
                _vm._v(_vm._s(_vm.$t("txtType0")))
              ]),
              _vm._v(" "),
              _c("option", { domProps: { value: 1 } }, [
                _vm._v(_vm._s(_vm.$t("txtType1")))
              ]),
              _vm._v(" "),
              _c("option", { domProps: { value: 2 } }, [
                _vm._v(_vm._s(_vm.$t("txtTypeResouce")))
              ]),
              _vm._v(" "),
              _c("option", { domProps: { value: 3 } }, [
                _vm._v(_vm._s(_vm.$t("txtType3")))
              ]),
              _vm._v(" "),
              _c("option", { domProps: { value: 4 } }, [
                _vm._v(_vm._s(_vm.$t("txtTypeUser")))
              ])
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mb-1" }, [
        _c("div", { staticClass: "col-sm-4" }, [
          _vm._v(" " + _vm._s(_vm.$t("txtStatus")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-8" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.selectedPoi.status,
                expression: "selectedPoi.status"
              }
            ],
            staticClass: "form-control",
            attrs: { disabled: !_vm.edit, type: "text" },
            domProps: { value: _vm.selectedPoi.status },
            on: {
              input: function($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.selectedPoi, "status", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mb-1" }, [
        _c("div", { staticClass: "col-sm-4" }, [
          _vm._v(" " + _vm._s(_vm.$t("txtCreated")))
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-sm-8" },
          [
            _c("Datepicker", {
              attrs: { disabled: !_vm.edit },
              model: {
                value: _vm.selectedPoi.created,
                callback: function($$v) {
                  _vm.$set(_vm.selectedPoi, "created", $$v)
                },
                expression: "selectedPoi.created"
              }
            })
          ],
          1
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row mb-1" }, [
        _c("div", { staticClass: "col-sm-4" }, [
          _vm._v(" " + _vm._s(_vm.$t("txtLastChecked")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-8" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.selectedPoi.lastChecked,
                expression: "selectedPoi.lastChecked"
              }
            ],
            staticClass: "form-control",
            attrs: { disabled: !_vm.edit, type: "text" },
            domProps: { value: _vm.selectedPoi.lastChecked },
            on: {
              input: function($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.selectedPoi, "lastChecked", $event.target.value)
              }
            }
          })
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "row" }, [
        _c("div", { staticClass: "col-sm-4" }, [
          _vm._v(" " + _vm._s(_vm.$t("txtAddress")))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-8" }, [
          _c("input", {
            directives: [
              {
                name: "model",
                rawName: "v-model",
                value: _vm.selectedPoi.adress,
                expression: "selectedPoi.adress"
              }
            ],
            staticClass: "form-control",
            attrs: { disabled: !_vm.edit, type: "text" },
            domProps: { value: _vm.selectedPoi.adress },
            on: {
              input: function($event) {
                if ($event.target.composing) return
                _vm.$set(_vm.selectedPoi, "adress", $event.target.value)
              }
            }
          })
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }